module.exports = __webpack_public_path__ + "static/media/marvelous_08.057f3b9e.jpg";